import { getServiceCode } from '../../utils';
import { AUTHApi } from '../../network';

export const getLoggedUserService = async () => {
  const serviceCode = getServiceCode();
  if (serviceCode) {
    return await AUTHApi.security.me.services.getOne(serviceCode);
  }
};
